var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[(!_vm.AllowedDisplay)?_c('not-allowed'):_vm._e(),(!_vm.datas.success && _vm.datas.message)?_c('div',[_vm._v(_vm._s(_vm.datas.filename)+" "+_vm._s(_vm.datas.message))]):_vm._e(),(_vm.datas.success)?_c('v-btn',{staticClass:"primary",on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.datas.filename)+".docx")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }